import { LocalStorageKey } from './localStorageSchema'
import { validatedLocalStorage } from './validatedLocalStorage'

export const removeLocalStorageItem = (key: LocalStorageKey) => {
  validatedLocalStorage.removeItem(key)
}
